import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const MainStatsChartsRoot = styled(Col)(
    ({ theme }) => css`
        row-gap: ${theme.spacing[6]};
    `,
);
